<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.af_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.af_name" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['ten.vi']" clearable></el-input>
                    </el-form-item>
                  </b-col>

                  <!-- <b-col md="3">
                    <el-form-item label="Địa điểm" prop="dia_chi">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['dia_chi.dia_chi']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col> -->

                  <b-col md="3">
                    <el-form-item :label="aLang.af_type" prop="">
                      <!-- <el-select
                        v-model="mData.tableRules.dataSearch.value.loai_hinh_id"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listLoaiHinh"
                          :key="item.id"
                          :label="item.ten.vi"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_loai_hinh"
                        :fetch-suggestions="querySearchLoaiHinh"
                        placeholder="Chọn"
                        :trigger-on-focus="true"
                        @select="handleSelectLoaiHinh"
                        @change="handleSelectLoaiHinh"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten.vi }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.af_ratings" prop="">
                      <!-- <el-select
                        v-model="mData.tableRules.dataSearch.value.xep_hang_id"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listXepHang"
                          :key="item.id"
                          :label="item.ten.vi"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_xep_hang"
                        :fetch-suggestions="querySearchXepHang"
                        placeholder="Chọn"
                        :trigger-on-focus="true"
                        @select="handleSelectXepHang"
                        @change="handleSelectXepHang"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten.vi }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3">
                    <el-form-item label="Dịch vụ" prop="dich_vu_ids">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.dich_vu_ids"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listDichVu"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Giá thấp nhất" prop="gia.thap_nhat">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['gia.thap_nhat']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Giá cao nhất" prop="gia.cao_nhat">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value['gia.cao_nhat']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col> -->
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <!-- <b-row>
                <b-col md="3">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.ngon_ngu"
                    :placeholder="'Ngôn ngữ'"
                    @change="fn_selectData(mData.tableRules.dataSearch.value.ngon_ngu)"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listLanguage"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="3">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.danh_muc_id"
                    :placeholder="'Danh mục tin tức'"
                    @change="fn_tableSearch()"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listDanhMucCoSoLuuTru"
                      :key="item.id"
                      :label="item.ten"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </b-col>
                <b-col md="3">                  
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.doi_tuong_hien_thi"
                    :placeholder="'Đối tượng hiển thị'"
                    @change="fn_tableSearch()"                    
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listDoiTuongHienThi"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>                 
                </b-col>
              </b-row> -->
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>                 
          
          <el-table-column prop="ten.vi" :sortable="mData.tableRules.allowSorting" :label="aLang.af_name" min-width="200">
            <template slot-scope="scope">              
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.ten.vi}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="dia_chi.dia_chi"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.af_address"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="ten_loai_hinh"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.af_type"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="ten_xep_hang"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.af_ratings"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="tong_so_phong"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.af_total_number_of_rooms"
            width="150"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button> -->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import CoSoLuuTruModel from "./CoSoLuuTruModel";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";
import LoaiHinhCSLTApi from "../../../moduleApi/LoaiHinhCSLTApi";
import XepHangCSLTApi from "../../../moduleApi/XepHangCSLTApi";
// import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";


export default {
  data() {
    return {
      ten_loai_hinh:'',
      ten_xep_hang:'',
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "CoSoLuuTru", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(CoSoLuuTruModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listDichVu: [],
          listXepHang: [],
          listLoaiHinh: [],
          // listDoiTuongHienThi: DataService.doiTuongHienThi,
          // listLanguage: DataService.Languages,
          // trangThai: CoSoLuuTruModel.trangThai
        }
      }
    };
  },

  methods: {
    async querySearchLoaiHinh(queryString, cb) {
      queryString = queryString.trim();
      var results = queryString
        ? this.mData.dataDefault.listLoaiHinh.filter(
            item =>
              item.ten.vi.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listLoaiHinh;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectLoaiHinh(item) {
      this.mData.tableRules.dataSearch.value.loai_hinh_id = item.id;
      this.ten_loai_hinh = item.ten.vi;
    },
    async querySearchXepHang(queryString, cb) {
      queryString = queryString.trim();
      var results = queryString
        ? this.mData.dataDefault.listXepHang.filter(
            item =>
              item.ten.vi.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.mData.dataDefault.listXepHang;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectXepHang(item) {
      this.mData.tableRules.dataSearch.value.xep_hang_id = item.id;
      this.ten_xep_hang = item.ten.vi;
    },    
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: 
        this.mData.tableRules.filters
        // "loai_hinh_id:in:5e61be05f400221038bedd67"
      };
     
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }      
      
      let reqLoaiHinh= LoaiHinhCSLTApi.list({limit:1000});
      let reqXepHang= XepHangCSLTApi.list({limit:1000});

      let resLoaiHinh=await reqLoaiHinh;
      let resXepHang= await reqXepHang;

      this.mData.dataDefault.listLoaiHinh=resLoaiHinh.result;
      this.mData.dataDefault.listXepHang=resXepHang.result;
      
      let res = await CoSoLuuTruApi.list(dataFilter);
      // debugger;

       $.each(res.result, (index, item) => {
        let tenLoaiHinh= this.mData.dataDefault.listLoaiHinh.find(
            element => element.id == item.loai_hinh_id
          );
        if (tenLoaiHinh) {
          item.ten_loai_hinh = tenLoaiHinh.ten.vi;
        } else {
          item.ten_loai_hinh = "";
        }

        let tenXepHang= this.mData.dataDefault.listXepHang.find(
            element => element.id == item.xep_hang_id
          );
        if (tenXepHang) {
          item.ten_xep_hang = tenXepHang.ten.vi;
        } else {
          item.ten_xep_hang = "";
        }
       });
     
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {    
      return data;
    },

    //click button
    fn_handle(type, scope, row) {
      // if (type == "create") {
      //   this.$router.push({
      //     name: "Admin-" + this.mData.moduleName + "-create"
      //   });
      // }
      // if (type == "update") {
      //   this.$router.push({
      //     name: "Admin-" + this.mData.moduleName + "-update",
      //     params: { id: row.id }
      //   });
      // }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      // if (type == "delete") {
      //   this.$confirm(LanguageService.lang.c_deleteConfirm, {
      //     confirmButtonText: LanguageService.lang.c_agree,
      //     cancelButtonText: LanguageService.lang.c_cancel,
      //     type: "warning"
      //   })
      //     .then(() => {
      //       this.fn_delete(row.id);
      //     })
      //     .catch(() => {});
      // }
      // if (type == "disable") {
      //   this.$confirm(LanguageService.lang.user_disableConfirm, {
      //     confirmButtonText: LanguageService.lang.c_agree,
      //     cancelButtonText: LanguageService.lang.c_cancel,
      //     type: "warning"
      //   })
      //     .then(() => {
      //       this.fn_disable(row.id, true);
      //     })
      //     .catch(() => {});
      // }
      // if (type == "openDisable") {
      //   this.$confirm(LanguageService.lang.user_openDisableConfirm, {
      //     confirmButtonText: LanguageService.lang.c_agree,
      //     cancelButtonText: LanguageService.lang.c_cancel,
      //     type: "warning"
      //   })
      //     .then(() => {
      //       this.fn_disable(row.id, false);
      //     })
      //     .catch(() => {});
      // }
    },

   

    //delete
    async fn_delete(id) {
      await CoSoLuuTruApi.delete(id);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value['ten.vi']){
        this.mData.tableRules.dataSearch.value['ten.vi'] = this.mData.tableRules.dataSearch.value['ten.vi'].trim()
      }
      
      this.$refs["myForm"].validate(async valid => {
        if (valid) {          
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));     
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();        
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

  
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {},

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        

        

        let reqLoaiHinh= LoaiHinhCSLTApi.list({limit:1000});
        let resLoaiHinh=await reqLoaiHinh;
        this.mData.dataDefault.listLoaiHinh=resLoaiHinh.result;
        let tenLoaiHinh= this.mData.dataDefault.listLoaiHinh.find(
            element => element.id == this.mData.tableRules.dataSearch.value.loai_hinh_id
          );
        if (tenLoaiHinh) {
          this.ten_loai_hinh = tenLoaiHinh.ten.vi;
        } else {
          this.ten_loai_hinh = "";
        }
        //xep hang 
        let reqXepHang= XepHangCSLTApi.list({limit:1000});
        let resXepHang= await reqXepHang;
        this.mData.dataDefault.listXepHang=resXepHang.result;
        let tenXepHang= this.mData.dataDefault.listXepHang.find(
            element => element.id == this.mData.tableRules.dataSearch.value.xep_hang_id
          );
        if (tenXepHang) {
          this.ten_xep_hang = tenXepHang.ten.vi;
        } else {
          this.ten_xep_hang = "";
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
<style lang="scss">
.el-select-dropdown__wrap {
    // max-width: 320px;
}
.el-autocomplete.inline-input{
  width: 100%;
}
</style>

